import { Person, PersonThingRange } from '@eagle/core-data-types';
import { Stack, Typography, styled } from '@ethings/ui-toolkit';
import { Box, Link } from '@mui/material';
import { Variant } from '@mui/material/styles/createTypography';
import { SxProps, unstable_styleFunctionSx as unstableStyleFunctionSx } from '@mui/system';
import { FC, type JSX } from 'react';
import { useHref } from 'react-router-dom';
import { useCustomRoutes } from '../../hooks';
import { CacheDataTypes } from '../../types';
import { testid } from '../../util';
import { FetchOne } from '../fetch';

interface Props {
  'data-testid'?: string;
  variant?: Variant;
  data: PersonThingRange[];
  sx?: SxProps;
}

const StyledStack = styled(Stack)<{ mergedSx?: SxProps }>(({ mergedSx, theme }) => ({
  ...(unstableStyleFunctionSx({ sx: mergedSx, theme } as never) as Record<string, unknown>),
}));

export const ThingPersonList: FC<Props> = ({ data, variant, sx, ...props }): JSX.Element => {
  const { person: personRoute } = useCustomRoutes();
  const href = useHref(`/${personRoute}`);

  if (!data.length) return <></>;

  return (
    <StyledStack data-testid={props['data-testid']} direction="row" alignItems='center' mergedSx={sx}>
      {data.map((thingPerson, i: number) =>
        <Box key={i}>
          {i !== 0 && <Typography component='span' color="text.primary" variant={variant}>{' , '}</Typography>}
          <FetchOne
            dataType={CacheDataTypes.PERSON}
            id={thingPerson.personId}
            renderFactory={(person: Person) => (
              <Link
                data-testid={testid`thing-map-popup-person-${person._id}`}
                href={`${href}/${person._id}`}
                sx={{ cursor: 'pointer' }}
                variant={variant}
              >
                {person.display}
              </Link>
            )}
          />
        </Box>,
      )}
    </StyledStack>
  );
};
